// 调账

import { HttpOneFileList,HttpImportExcl } from '@/service/costbilling';
import TableList from "@components/templates/tablelist";
export default {
    props:["id"],
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
            },
            Plugins: {show: true},
            taskStatusList:[
                {value:0,label:'待下载'},
                {value:1,label:'下载中'},
                {value:2,label:'下载异常'},
                {value:3,label:'下载完成'},
                {value:4,label:'导入中'},
                {value:5,label:'导入异常'},
                {value:6,label:'导入完成'},
            ],
        };
    },
    methods: {
        ajaxRequest: HttpOneFileList,
        // startUp:1,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'uploadExcel':
                    this.operate = {
                        show: true,
                        alert: 'warning',
                        params: { itemIds: this.checkedData },
                        title: '导入',
                        ajaxRequest: HttpImportExcl,
                        callback:()=>{
                            this.$emit('on-update');
                            this.operate = {};
                        }
                    }
                break;
                case 'downFile':
                    this.handleWebfs(params, {},'download')
                break;
            }
        },
    },
    computed: {
        ToolsData() {
            return [
                {
                    name: "导入",
                    operate: "uploadExcel",
                    theme: "info",
                    batch:true,
                },
            ]
        },

        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title:"导入编号",
                    key: 'importTaskNo',
                    render: (h,{row})=>{
                        return <div>{row.importTaskNo || '--'}</div>
                    }
                },
                {
                    title: '文件名称',
                    key: 'fileName',
                    render:(h,{row})=>{
                        return <div>
                            {/* <a onClick={this.handleOperates.bind(this, row.fileUrl, 'downFile')}>{row.fileName}</a> */}
                            <a target = '_blank'  href={row.fileUrl} download={row.fileUrl} >{row.fileName}</a>
                        </div>
                    }
                },
                {
                    title: '发票日期',
                    key: 'fileDate',
                },
                {
                    title: '账户',
                    key: 'account',
                },
                {
                    title: '任务状态',
                    key: 'status',
                    render: (h, { row }) => this.findRenderLabel(this.taskStatusList, row.status)
                }];
        },
    },
};





